module.exports = __webpack_public_path__ + "static/img/6-Pod-Point-and-its-electric-vehicle-charging-infrastructure.10976612.jpg";